<template>
<div id="nissan-quiz-attract-ipad" class="nissan-quiz-screen">
  <div class="fill flex-center">
    <form @submit.prevent="enterGame" id="gameIdForm" v-if="canDisplayForm">
      <div class="attractTitle">
        Next trivia game starting soon!<br>
        See a product specialist for scheduled times
      </div>
      <div v-if="invalidGameRoomId" class="invalidGameRoomMsg">
        This game room is invalid, please check again!
      </div>
      <input
        v-model="gameRoomId"
        class="nissan-quiz-input"
        id="nissan-quiz-room-id"
        name="gameRoomId"
        placeholder="00000"
        pattern="[0-9]{5}"
        type="text"
        size="5"
        maxlength="5"
        required
        min="10000"
        max="99999"
      />
      <button class="submit-button" id="nissan-quiz-enter-game-submit">
        <span>ENTER GAME</span>
      </button>
    </form>
  </div>
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Attract',
  mounted() {
    console.log(`[Attract](mounted) gameRoomIdSubmitted: ${this.gameRoomIdSubmitted}`);
    this.gameRoomIdSubmitted = false;
    this.$keen.recordEvent('pages', {
      item: 'attract',
    });
    const urlParams = new URLSearchParams(window.location.search);
    const gameRoomId = urlParams.get('gameRoomId');
    const tierType = urlParams.get('tierType');

    if (gameRoomId) {
      this.gameRoomId = gameRoomId;
      // window.history.replaceState(
      //   'end',
      //   '',
      //   window.location.href.replace(`?gameRoomId=${this.gameRoomId}`, ''),
      // );
    }

    if (tierType) {
      this.tierType = tierType.toUpperCase();
      this.setTierType({ tierType: this.tierType });
      // window.history.replaceState(
      //   'end',
      //   '',
      //   window.location.href.replace(`&tierType=${this.tierType}`, ''),
      // );
    }

    this.checkTierType();
  },
  computed: {
    ...mapGetters([
      'invalidGameRoomId',
    ]),
  },
  watch: {
    invalidGameRoomId() {
      console.log(`[Attract](invalidGameRoomId) gameRoomIdSubmitted: ${this.gameRoomIdSubmitted}`);
      this.gameRoomIdSubmitted = false;

      // If tier type is TIER3 and the event was not found on the backend
      // So we need to start the game on the backend
      if (this.tierType === 'TIER3') {
        this.$root.$emit('requestStartTIER3');
      }
    },
  },
  data() {
    return {
      gameRoomId: '',
      gameRoomIdSubmitted: false,
      canDisplayForm: false,
      tierType: undefined,
    };
  },
  methods: {
    ...mapMutations([
      'setInvalidGameRoomId',
      'setTierType',
    ]),
    enterGame() {
      console.log(`[Attract](enterGame) gameRoomIdSubmitted: ${this.gameRoomIdSubmitted}`);
      // Prevent spam on buttons
      if (this.gameRoomIdSubmitted) {
        return;
      }

      this.setInvalidGameRoomId({
        value: false,
      });
      this.gameRoomIdSubmitted = true;

      // this.$store.commit('setGameRoomId', { gameRoomId: 0 });
      setTimeout(() => {
        // this.$store.commit('setInvalidGameRoomId', { value: false });
        if (this.tierType === 'TIER3' && this.gameRoomId === '50017812') {
          this.$store.commit('setIsTIER3SpecialEvent', { isTIER3SpecialEvent: true });
        }
        this.$store.commit('setGameRoomId', { gameRoomId: this.gameRoomId });
      });
    },
    checkTierType() {
      if (this.tierType && (this.tierType === 'TSF' || this.tierType === 'CORP' || this.tierType === 'TIER3')) {
        this.enterGame();
      } else {
        this.canDisplayForm = true;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss">
 @import './../styles/_global.scss';
 @import './../styles/_variables.scss';


.text-block {
  font-size: 14px;
  text-align: center;
  margin: 75px 90px 0;
}

.attractTitle {
  margin-top: 137px;
  font-size: 14px;
  text-align: center;
  width: 100%;
}
@media only screen and (min-width: 600px) {
  .attractTitle {
    font-size: 20px;
  }
}
@media only screen and (max-width: 320px) {
  .attractTitle {
    font-size: 12px;
  }
}

.trivia-logo {
    width: 90%;
    display: block;
    margin: 282px auto 0;
}

.invalidGameRoomMsg {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
#gameIdForm {
  margin-bottom: 40px;
  width: 100%;
}

.submit-button {
  display: block;
  height: 100px;
  width: 80%;
  background-size: 600px 100px;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  margin: 25px auto 0;
  color: white;
  background-color: black;
  border: 2px solid;
}

input.nissan-quiz-input {
  position: relative;
  display: block;
  background-color: transparent;
  border: 2px solid #FFF;
  width: 80%;
  color: #FFF;
  font-size: 16px;
  height: 45px;
  text-align: center;
  font-weight: bold;
  line-height: 18px;
  text-transform: uppercase;
  margin: 5px auto 0;
  padding: 8px 0;
  &::placeholder {
    color: #fff;
  }
}
</style>
